











import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class LoadingOverlay extends Vue {
  @Prop({ default: false }) loading?: boolean;
  @Prop() minDelay?: number | null;

  internalLoading = false;

  @Watch("loading")
  loadingStarted(fresh: boolean) {
    if (fresh) {
      this.internalLoading = true;
      setTimeout(() => {
        this.internalLoading = false;
      }, this.minDelay ?? 550);
    }
  }
}
